// src/pages/Dashboard.jsx
import React, {useEffect} from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { List, ListItem, ListItemText, ListItemButton, ListItemIcon, Box } from "@mui/material";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { getPetOwnerById } from "../../api/petOwnerService";
import PetOwnerForm from "../../components/patients/forms/PetOwnerForm";
import PetOwnerView from "../../components/patients/modals/PetOwnerView";
import Button from "@mui/material/Button";
import VerifiedIcon from '@mui/icons-material/Verified';
import Stack from "@mui/material/Stack";
import { useAuth } from "../../hooks/useAuth";
import ConfirmDialog from "../../components/common/modals/ConfirmDialog";
import { useConfirmDialog } from "../../hooks/ui/useConfirmDialog";
import ConsentDialog from "../../components/common/modals/ConsentDialog";

const QrPage = () => {

    const { t } = useTranslation('common');

    const { isAuthenticated, role, handleLogout } = useAuth();

    const { open, options, showDialog, handleConfirm, handleCancel } = useConfirmDialog();

    const handleDone = () => {
        handleLogout();
    };

    const activeCompanyName = localStorage.getItem("activeOfficeName");

    const [petOwnerFormOpen, setPetOwnerFormOpen] = React.useState(false);
    const [petFormMode, setPetFormMode] = React.useState('create');
    const [selectedPetOwner, setSelectedPetOwner] = React.useState(null);
    const [petOwnerViewOpen, setPetOwnerViewOpen] = React.useState(false);
    const [consentDialogOpen, setConsentDialogOpen] = React.useState(false);

    const handleAdd = () => {
        if (selectedPetOwner) {
            setPetOwnerViewOpen(true);
        } else {
            setSelectedPetOwner(null);
            setPetFormMode("create");
            setPetOwnerFormOpen(true);
        }
    };

    const handleEdit = () => {
        setPetFormMode("edit");
        setPetOwnerFormOpen(true);
    };

    const onSavePetOwnerSuccess = async (savedPetOwner) => {
        const updatedPetOwner = await getPetOwnerById(savedPetOwner.id);
        setSelectedPetOwner(updatedPetOwner);
        if (!petOwnerViewOpen) setPetOwnerViewOpen(true);
    };

    useEffect(() => {
        setConsentDialogOpen(true);
    }, []);

    return (
        <>
        <Box
            component="img"
            src="/images/new_patient.png"
            alt="Patient"
            sx={{ width: "100%", height: "auto", borderRadius: 3 }}
        />

        <Typography variant="h4" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
            {activeCompanyName}
        </Typography>
        <Typography variant="h4" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
            New Patient Registration
        </Typography>
        <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
            {t('guests.messages.click_new_patient')}
        </Typography>
        <List>
            <ListItem>
                <ListItemButton onClick={handleAdd}>
                <ListItemIcon>
                    <PersonAddAlt1Icon fontSize='large' color='secondary' />
                </ListItemIcon>
                <ListItemText 
                    primary="New Patient"
                    secondary="create new pet owner and pet(s) record"
                />
                </ListItemButton>
            </ListItem>
        </List>
        {selectedPetOwner ?
        <>
        <Stack spacing={2}>
        <Typography variant="body2" sx={{ mt: 0 }}>Please review all entered information by clicking New Patient. Make sure everything's correct.</Typography>
        <Typography variant="body2" sx={{ mt: 0 }}>Click All Done if you'r sure everything's in order.</Typography>
        <Button 
            onClick={() => {
                showDialog({
                    title: "All Done?",
                    content: t('guests.messages.confirm_done'),
                    confirmText: "Done!",
                    cancelText: "Cancel",
                    onConfirm: handleDone,
                })}} 
            fullWidth variant="outlined" 
            component="span" 
            startIcon={<VerifiedIcon />}
        >
            All Done!
        </Button>
        </Stack>
        </>
        : null }
        <PetOwnerView 
            handleEdit={handleEdit}
            setPetOwners={null}
            petOwner={selectedPetOwner}
            open={petOwnerViewOpen}
            onClose={() => setPetOwnerViewOpen(false)}
        />
        <PetOwnerForm 
            successCallback={onSavePetOwnerSuccess}
            setPetOwners={null} 
            petOwner={selectedPetOwner}
            mode={petFormMode}
            open={petOwnerFormOpen}
            onClose={() => setPetOwnerFormOpen(false)}
        />
        <ConfirmDialog
            open={open}
            options={options}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
        />
        <ConsentDialog
            open={consentDialogOpen}
            setOpen={setConsentDialogOpen} 
        />
        </>
    );
};

export default QrPage;
